/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";
import Icon from "./Icon";
import './AILoader.css';

export default class AILoader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            seconds: 0,
            messageIndex: 0
        };

        this.messages = props.messages || [
            "Reading document...",
            "Extracting text and structure...",
            "Identifying key information...",
            "Analyzing document content...",
            "Preparing results..."
        ];
    }

    componentDidMount() {
        this.timer = setInterval(() => {
            this.setState(state => ({
                seconds: state.seconds + 1
            }));
        }, 1000);

        this.messageTimer = setInterval(() => {
            this.setState(state => ({
                messageIndex: (state.messageIndex + 1) % this.messages.length
            }));
        }, 3000);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
        clearInterval(this.messageTimer);
    }

    formatTime = seconds => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;

        if (minutes === 0)
            return `${secs}s`;

        return `${minutes}:${secs.toString().padStart(2, "0")}`;
    };

    render() {
        return (
            <div className="document-analysis-loader">
                <div className="document-analysis-icon">
                    <Icon icon="faFileLines" />
                </div>

                <div className="document-analysis-content">
                    <div className="d-flex align-items-center justify-content-between">
                        <strong>Analyzing Document</strong>

                        <span className="document-analysis-time">
                            {this.formatTime(this.state.seconds)}
                        </span>
                    </div>

                    <div className="document-analysis-description">
                        AI is reviewing the document and extracting relevant information.
                    </div>

                    <div className="document-analysis-progress d-none">
                        <div className="document-analysis-progress-bar" />
                    </div>

                    <div className="document-analysis-status">
                        <span className="document-analysis-dot" />
                        {this.messages[this.state.messageIndex]}
                    </div>
                </div>
            </div>
        );
    }
}